<template>
    <div>

        <div>
            <InertiaLink
                href="/central/schools"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconSchool
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                />
                {{ $tc('messages.schools', 2) }}
            </InertiaLink>
            <InertiaLink
                href="/central/guest_practices"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconCards
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                />
                {{ $t('messages.quest_practices') }}
            </InertiaLink>
            <InertiaLink
                href="/central/adverts"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconCards
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                />
                {{ $tc('messages.adverts', 2) }}
            </InertiaLink>
        </div>

    </div>
</template>

<script>
export default {
    name: 'SidebarItemsForCentral',
};
</script>
<script setup>
import {
    IconCards,
    IconSchool,
} from '@tabler/icons-vue';

const props = defineProps({
    sections: {
        type: Array,
        required: false,
        default: () => [],
    },
});


const version = {
    iconClasses: 'mr-3',
    anchorClasses: 'text-sm leading-5',
};
</script>
